import { Injectable } from '@angular/core';

@Injectable()
export class ErrorParseService {
    constructor() { }

    public foundKeyWord(searchItem: any, keyWord: string): boolean {

        let keyWordExists: boolean;
        let temp: string = searchItem instanceof Object ? searchItem.message : searchItem;
        if (temp !== undefined && temp.toLocaleLowerCase().indexOf(keyWord.toLocaleLowerCase()) > -1) {
            keyWordExists = true;
        } else {
            keyWordExists = false;
        }

        return keyWordExists;

    }

    public translateCCError(inputMsg: string): string {
        const CORP_COMMON_WS = "CORPCOMMONWS";
        const SESSION_TIMEOUT = "SESSIONTIMEOUT";

        let keyWord: string = "";
        let outputMsg: string = inputMsg;
        if (this.foundKeyWord(inputMsg, CORP_COMMON_WS)) {
            keyWord = CORP_COMMON_WS;
        } else if (this.foundKeyWord(inputMsg, "Session is not active")) {
            keyWord = SESSION_TIMEOUT;
        }


        switch (keyWord) {
            case CORP_COMMON_WS:
                outputMsg = "Unable to connect to the remote server";
                break;
            case SESSION_TIMEOUT:
                outputMsg = "Your session has timed out";
                break;
            default:
                outputMsg = inputMsg;
                break;
        }
        return outputMsg;
    }
}